import React from 'react';
import '../css/landing.css';
import logo from '../assets/big_logo.svg';
import location from '../assets/location.svg';
import phone from '../assets/phone.svg';
import { Button, withStyles } from '@material-ui/core';

const WhiteButton = withStyles({
    root: {
        color: 'white',
        border: '2px solid white',
        borderRadius: '30px',
        '&:hover': {
            border: '2px solid grey',
        },
        fontFamily: 'Open Sans',
        fontSize: '1.1em',
        marginTop: '1em',
    },
})(Button);
const Landing = (props) => {
    return (
        <main className="bg">
            <div className="center">
                <img src={logo} alt="main logo" className="logo" />
                <div className="subtitle">Liquor Store in East Windsor</div>
                <div className="icons">
                    <img src={location} alt="Location icon" className="icon" />
                    <img src={phone} alt="Location icon" className="icon" />
                </div>
                <WhiteButton
                    variant="outlined"
                    color="primary"
                    onClick={() => props.history.push('./liquors')}
                >
                    Browse Our Selection
                </WhiteButton>
            </div>
        </main>
    );
};

export default Landing;
